import { ComponentPropsWithoutRef, ReactElement } from "react";
import { SectionBlockVideo as ISectionBlockVideo } from "~/sanity/types";
import Grid from "~/components/globals/Grid";
import * as styles from "./SectionBlockVideo.css";
import { Heading } from "~/components/elements/Heading";
import { Paragraph } from "~/components/elements/Paragraph";

export type SectionBlockVideoProps = ComponentPropsWithoutRef<"div"> & {
  data: ISectionBlockVideo;
  icon?: ReactElement;
};

export const SectionBlockVideo = ({
  data,
  icon,
  ...props
}: SectionBlockVideoProps) => {
  const { videoSrc } = data;

  const isValidYoutubeEmbedUrl = (url: string) => {
    const youtubeEmbedRegex =
      /^(https?:\/\/)?(www\.)?(youtube\.com\/embed\/[a-zA-Z0-9_-]+)(\?.*)?$/;
    return youtubeEmbedRegex.test(url);
  };

  return (
    <section>
      <Grid className={styles.wrapper} {...props}>
        <div className={styles.content}>
          {videoSrc && isValidYoutubeEmbedUrl(videoSrc) ? (
            <iframe
              width="100%"
              height="100%"
              src={videoSrc}
              title="Video Player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          ) : (
            <div className={styles.error}>
              <Paragraph size="smMd">
                Sorry, the video you're looking for is currently unavailable.
              </Paragraph>
            </div>
          )}
        </div>
      </Grid>
    </section>
  );
};
